import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";

import { action, makeObservable, observable } from "mobx";

class VehicleAllocateStore {
  allocateVehicles = [];
  loading = false;
  total = 0;
  // for asset dropdown
  allocateVehicleAsset = [];
  // for project dropdwn
  projectList = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      allocateVehicles: observable,
      loading: observable,
      total: observable,
      loadData: action,
      addData: action,
      getAllocateVehicles: action,
      getProjectDetails: action,
      addProjectData: action,
      exportExcel: action,
      // getAssetData:action
    });
    this.rootStore = rootStore;
  }

  // async loadData({ companyId, offset, limit, searchField, isadmin, userId }) {
  //   this.loading = true;
  //   var queryParams = {
  //     companyId: companyId,
  //     offset: offset,
  //     limit: limit,
  //     searchField: searchField,
  //     // isadmin: isadmin,
  //     // userId: userId,
  //   };

  //   var response = await postApi
  //     .getClient()
  //     .get("http://localhost:3052/assignVehicleList/getAssignVehicles", {
  //       params: queryParams,
  //     });
  //   console.log("allocate", response);
  //   console.log(response?.data?.data);
  //   this.allocateVehicles = response?.data?.data?.assignvehicles;
  //   this.total = parseInt(response?.data?.data?.TotalCount);
  //   this.loading = false;
  // }

  async loadData({ companyId, offset, limit, searchField, isadmin, userId }) {
    this.loading = true;
    var queryParams = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      searchField: searchField,
      isadmin: isadmin,
      userId: userId,
    };

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("assignVehicleList/getAssignVehicles", {
        params: queryParams,
      });
    this.allocateVehicles = response?.data?.data?.assignvehicles;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  // async addData(allocateVehicleData) {
  //   console.log(allocateVehicleData);
  //   var postData = allocateVehicleData;

  //   var response = await postApi
  //     .getClient()
  //     .post("http://localhost:3052/assignVehicleList/assignVehicle", postData);
  //   console.log(response, "post");
  //   return response;
  // }

  async addData(allocateVehicleData) {
    var postData = allocateVehicleData;

    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("assignVehicleList/assignVehicle", postData);
    return response;
  }
  // async getAllocateVehicles({ companyId, asset }) {
  //   console.log(asset, "sadfsdfd");
  //   if (asset === 1) {
  //     var postData = {
  //       tokenId: "",
  //       companyId: companyId,
  //       userid: null,
  //       isadmin: null,
  //       asset: asset,
  //     };

  //     // const base64Input = await base64_encode(JSON.stringify(postData));
  //     // var response = await postApi.getClient().post("index.php?c=allocatevehicle&a=getallocateVehicles",
  //     //     "postData=" + base64Input
  //     //   );
  //     const response = await postApi
  //       .getClient("NodeCoreUrl")
  //       .get("assignVehicleList/getAllocateVehiclesData", {
  //         params: postData,
  //       });
  //     console.log(response, "post");
  //     this.assetList = response?.data?.data;
  //     return response?.data?.data;
  //   } else {
  //     var postData = {
  //       tokenId: "",
  //       companyId: companyId,
  //       userid: null,
  //       isadmin: null,
  //       asset: asset,
  //     };
  //     const response = await postApi
  //       .getClient("NodeCoreUrl")
  //       .get("assignVehicleList/getAllocateVehiclesData", {
  //         params: postData,
  //       });
  //     // const base64Input = await base64_encode(JSON.stringify(postData));
  //     // var response = await postApi
  //     //   .getClient()
  //     //   .post(
  //     //     "index.php?c=allocatevehicle&a=getallocateVehicles",
  //     //     "postData=" + base64Input
  //     //   );
  //     console.log(response, "post");
  //     this.assetList = response?.data?.data;
  //     return response?.data?.data;
  //   }
  // }

  // to get asset data

  // async getAllocateVehicles({ companyId, asset }) {
  //   console.log(asset,"asssset");
  //   if (asset==1) {

  //     var postData = {
  //       tokenId: "80bovn8u800tg1aq9bvr73kbhh",
  //       companyId: companyId,
  //       userid: null,
  //       isadmin: null,
  //       asset: asset,
  //     };
  //     const base64Input = await base64_encode(JSON.stringify(postData));
  //     var response = await postApi
  //       .getClient()
  //       .post(
  //         "index.php?c=allocatevehicle&a=getallocateVehicles",
  //         "postData=" + base64Input
  //       );
  //     // console.log(response, "post");
  //     // if (asset == "1") {
  //     //   this.allocateVehicleAsset = response?.data?.vehicles;
  //     // } else {
  //     //   this.allocateVehicleAsset = response?.data?.data?.vehicles;
  //     // }
  //   } else {
  //     var postData = {
  //       tokenId: "80bovn8u800tg1aq9bvr73kbhh",
  //       companyId: companyId,
  //       userid: null,
  //       isadmin: null,
  //       asset: asset,
  //     };
  //   }
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=allocatevehicle&a=getallocateVehicles",
  //       "postData=" + base64Input
  //     );
  //   console.log(response, "post");
  //   this.allocateVehicleAsset = response?.data?.data?.vehicles;

  //   return response?.data?.data?.vehicles;
  // }

  async getAllocateVehicles({ companyId, asset }) {
    if (asset === 1) {
      var postData = {
        tokenId: "",
        companyId: companyId,
        userid: null,
        isadmin: null,
        asset: asset,
      };

      var response = await postApi
        .getClient("NodeCoreUrl")
        .get("assignVehicleList/getAllocateVehiclesData", {
          params: postData,
        });
      this.assetList = response?.data?.data?.vehicles;
      return response?.data?.data?.vehicles;
    } else {
      var postData = {
        tokenId: "",
        companyId: companyId,
        userid: null,
        isadmin: null,
        asset: asset,
      };

      var response = await postApi
        .getClient("NodeCoreUrl")
        .get("assignVehicleList/getAllocateVehiclesData", {
          params: postData,
        });
      this.assetList = response?.data?.data?.vehicles;
      return response?.data?.data?.vehicles;
    }
  }

  // async getAllocateVehicleData(Id) {
  //   console.log("Id", Id);
  //   var postData = { aid: Id, limit: 1, offset: 0 };
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=allocatevehicle&a=getallocateList",
  //       "postData=" + base64Input
  //     );
  //   //  console.log(response)
  //   return response.data.data.assignvehicles[0];
  // }

  async getAllocateVehicleData(Id) {
    var postData = { aid: Id, limit: 1, offset: 0 };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("assignVehicleList/getAssignVehicles", {
        params: postData,
      });
    return response.data.data.assignvehicles[0];
  }

  async deleteRecord({ Id }) {
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete(`assignVehicleList/deleteAssignVehicle/${Id}`);
    return response;
  }

  // To get project details
  async getProjectDetails(companyId) {
    var postData = { companyId: companyId };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("project/getProject", {
        params: postData,
      });
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=project&a=getProject", "postData=" + base64Input);
    // console.log(response, "post");
    this.projectList = response?.data?.data;
    return response?.data?.data;
  }

  // To add project details
  async addProjectData(postData) {
    // console.log(projectDetails);
    var projectDetails = { postData };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("project/addProject", projectDetails);
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=project&a=addproject", "postData=" + base64Input);
    // console.log(response, "post");
    return response;
  }

  async exportExcel(getData) {
    console.log(getData);
    try {
      var response = await postApi
        .getClient("NodeCoreUrl")
        .post("assignVehicleList/exportAllocated", getData, {
          responseType: "blob",
        });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Allocate Vehicle Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
    // window.location.href =
    //   "http://localhost:3052/assignVehicleList/exportAllocated&cid=" +
    //   getData.cid +
    //   "&searchField=" +
    //   getData.searchField +
    //   "&colList=" +
    //   getData.colList;
  }
}

export default VehicleAllocateStore;
